import React from 'react';

export function SelectModal({error, name, title, value, children, disabled, onChange}) {

  return <div className="modal__group">
    <p className="modal__help">{title}</p>
    <select name={name}
            className={"modal__select select" + (error ? " select--error" : "")}
            value={value}
            disabled={disabled}
            onChange={onChange}>
      {children}
    </select>
  </div>;
}
